import { render, staticRenderFns } from "./OnlineOfferForbiddenWarningModal.vue?vue&type=template&id=bff7a624"
import script from "./OnlineOfferForbiddenWarningModal.vue?vue&type=script&lang=js"
export * from "./OnlineOfferForbiddenWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports